export interface IWarehouseAdminProductBuildingSpecificationData {
    building: string;
    min_stock: number|null;
    max_stock: number|null;
    disabled: boolean;
    rack: string|null;
    layer: string|null;
}

export default class WarehouseAdminProductBuildingSpecificationData {
    public building: string;
    public min_stock: number|null;
    public max_stock: number|null;
    public disabled: boolean;
    public rack: string|null;
    public layer: string|null;

    constructor(data: IWarehouseAdminProductBuildingSpecificationData) {
        this.building = data.building;
        this.min_stock = data.min_stock === null
            ? null
            : Number(data.min_stock);
        this.max_stock = data.max_stock === null
            ? null
            : Number(data.max_stock);
        this.disabled = Boolean(data.disabled);
        this.rack = data.rack ?? null;
        this.layer = data.layer ?? null;
    }
}